import { render, staticRenderFns } from "./SignupLinkNew.vue?vue&type=template&id=543fbda4"
import script from "./SignupLinkNew.vue?vue&type=script&lang=js"
export * from "./SignupLinkNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports